// global.js
document.addEventListener('DOMContentLoaded', () => {
  // Intersection Observer for Scroll Animations
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.15
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        // Only animate once
        if (entry.target.hasAttribute('data-once')) {
          observer.unobserve(entry.target);
        }
      }
    });
  }, observerOptions);

  const animatedElements = document.querySelectorAll('.bh-fade-in-up, .bh-fade-in, .bh-scale-in, .bh-fade-in-left, .bh-fade-in-right');
  animatedElements.forEach(el => observer.observe(el));
});

// TTP Leathers Native Wishlist System
window.TTPWishlist = {
  storageKey: 'ttp_wishlist',

  get() {
    try {
      const items = localStorage.getItem(this.storageKey);
      return items ? JSON.parse(items) : [];
    } catch (e) {
      return [];
    }
  },

  set(items) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(items));
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: items }));
    } catch (e) {
      console.error('Failed to save wishlist', e);
    }
  },

  add(handle) {
    const items = this.get();
    if (!items.includes(handle)) {
      items.push(handle);
      this.set(items);
    }
  },

  remove(handle) {
    let items = this.get();
    items = items.filter(item => item !== handle);
    this.set(items);
  },

  has(handle) {
    return this.get().includes(handle);
  },

  toggle(handle) {
    if (this.has(handle)) {
      this.remove(handle);
      return false; // Removed
    } else {
      this.add(handle);
      return true; // Added
    }
  },

  updateButtons() {
    const items = this.get();
    document.querySelectorAll('[data-wishlist-handle]').forEach(btn => {
      const handle = btn.getAttribute('data-wishlist-handle');
      const isActive = items.includes(handle);
      if (isActive) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-label', 'Add to wishlist');
      }

      // Handle product detail page text changes
      const textSpan = btn.querySelector('.bh-wishlist-text');
      if (textSpan) {
        textSpan.textContent = isActive ? 'REMOVE FROM WISHLIST' : 'ADD TO WISHLIST';
      }
    });
  },

  init() {
    this.updateButtons();

    // Event delegation for clicks
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wishlist-handle]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const handle = btn.getAttribute('data-wishlist-handle');
      this.toggle(handle);
      this.updateButtons();
    });

    // Listen for updates from other tabs / modules
    document.addEventListener('wishlist:updated', () => {
      this.updateButtons();
    });
  }
};

// Initialize Wishlist
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => window.TTPWishlist.init());
} else {
  window.TTPWishlist.init();
}
